import React from 'react';
import { Link } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { trackCta } from '../analytics';
import {
  BOOK_DEMO_LABEL,
  BOOK_DEMO_NAV_LABEL,
  BOOK_DEMO_PAGE_PATH,
} from '../lib/bookDemo';
import './BookDemoButton.css';

const MotionLink = motion(Link);

/**
 * Demo booking CTA — routes to the on-site /book-demo page (embedded scheduler).
 * Pass variant="nav" in the site header (compact pill on desktop, full button in mobile menu).
 */
export function BookDemoButton({ placement, className = '', onPress, variant = 'default' }) {
  const reduceMotion = useReducedMotion();
  const isNav = variant === 'nav';
  const classes = ['btn', 'btn-demo', isNav ? 'btn-demo--nav' : '', className]
    .filter(Boolean)
    .join(' ');
  const motionProps = isNav
    ? {
        whileHover: reduceMotion ? undefined : { y: -1 },
        whileTap: reduceMotion ? undefined : { scale: 0.98 },
      }
    : {
        whileHover: reduceMotion ? undefined : { scale: 1.03, y: -2 },
        whileTap: reduceMotion ? undefined : { scale: 0.98 },
      };

  return (
    <MotionLink
      to={BOOK_DEMO_PAGE_PATH}
      className={classes}
      {...motionProps}
      onClick={() => {
        trackCta('book_demo', placement);
        onPress?.();
      }}
    >
      {isNav ? (
        <>
          <span className="btn-demo-label btn-demo-label--nav-short">{BOOK_DEMO_NAV_LABEL}</span>
          <span className="btn-demo-label btn-demo-label--nav-full">{BOOK_DEMO_LABEL}</span>
        </>
      ) : (
        BOOK_DEMO_LABEL
      )}
      <ArrowRight className="ui-icon-2xl btn-demo-arrow" aria-hidden />
    </MotionLink>
  );
}

export default BookDemoButton;
